module.exports = __webpack_public_path__ + "static/img/kaiyi1.a34dbf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/kaiyi1.png
// module id = 1xPf
// module chunks = 5